class SortByDropdown extends HTMLElement {
  constructor() {
    super();

    this.selectSelector = 'select[name="sort_by"]';
    this.gridSelector = '#ProductsGrid';

    this.abortController = null;

    // Bind handlers
    this.onChange = this.onChange.bind(this);
    this.onPopState = this.onPopState.bind(this);
  }

  connectedCallback() {
    this.cacheDom();
    this.initEvents();
    this.syncSelectWithUrl();
  }

  disconnectedCallback() {
    this.removeEvents();
  }

  /* ----------------------------------------
      DOM Cache
  ----------------------------------------- */
  cacheDom() {
    this.selectEl = this.querySelector(this.selectSelector);
    this.grid = document.querySelector(this.gridSelector);
    this.loader = document.querySelector('collection-loader');
  }

  /* ----------------------------------------
      Event Management
  ----------------------------------------- */
  initEvents() {
    if (!this.selectEl) return;

    this.selectEl.addEventListener('change', this.onChange);
    window.addEventListener('popstate', this.onPopState);
  }

  removeEvents() {
    if (this.selectEl) {
      this.selectEl.removeEventListener('change', this.onChange);
    }
    window.removeEventListener('popstate', this.onPopState);
  }

  /* ----------------------------------------
      URL Sync
  ----------------------------------------- */
  syncSelectWithUrl() {
    if (!this.selectEl) return;

    const params = new URLSearchParams(window.location.search);
    const sortParam = params.get('sort_by');

    this.selectEl.value = sortParam || this.selectEl.dataset.defaultSortby || '';
  }

  /* ----------------------------------------
      Sorting Change
  ----------------------------------------- */
  onChange(e) {
    const value = e.target.value;
    if (!value) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);

    this.fetchPage(url.toString());
  }

  onPopState() {
    this.syncSelectWithUrl();
  }

  /* ----------------------------------------
      Fetch + Render
  ----------------------------------------- */
  async fetchPage(url, pushState = true) {
    // Cancel pending requests
    this.abortController?.abort();
    this.abortController = new AbortController();

    this.loader?.show?.('מסדר תוצאות...');

    try {
      const res = await fetch(url, {
        signal: this.abortController.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.querySelector(this.gridSelector);
      if (newGrid && this.grid) {
        this.grid.innerHTML = newGrid.innerHTML;
      }

      // Refresh infinite scroller if exists
      const infinity = document.querySelector('infinity-products');
      infinity?.refresh?.();

      // Update dropdown after navigation
      const params = new URLSearchParams(url.split('?')[1] || '');
      const sortParam = params.get('sort_by');
      if (sortParam) {
        this.selectEl.value = sortParam;
      }

      if (pushState) {
        history.pushState({}, '', url);
      }
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('[SortByDropdown]', err);
        window.location.href = url;
      }
    } finally {
      this.loader?.hide?.();
    }
  }
}

customElements.define('sort-by-dropdown', SortByDropdown);
